import UndoIcon from '@mui/icons-material/Undo';
import { IconButton, Tooltip } from '@mui/material';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { SELECTION_COLUMN_ID } from '@work4all/components/lib/dataDisplay/basic-table/utils/makeRowsSelectable';

import { useSetting } from '@work4all/data/lib/settings/use-setting';

import { useDeepMemo } from '@work4all/utils/lib/hooks/use-deep-memo';

import { settings } from '../../../../settings';

export const useColumnSettings = (columns: string[], groupByType) => {
  const { t } = useTranslation();
  const columnSettings = useSetting(
    settings.erpPositionsConfig(`conversion.${groupByType}`, {
      visibility: [SELECTION_COLUMN_ID, ...columns],
      order: [] as string[],
      width: {} as Record<string, number>,
    })
  );
  return {
    columnSettings,
    element: (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Tooltip title={t('LISTS_PAGES.RESET_COLUMNS')}>
          <IconButton onClick={columnSettings.delete}>
            <UndoIcon color="primary" />
          </IconButton>
        </Tooltip>
      </div>
    ),
  };
};

export const useColumnsWidth = (groupByType) => {
  const columnSettings = useSetting(
    settings.erpPositionsConfig(`conversion.${groupByType}`, {
      visibility: [SELECTION_COLUMN_ID],
      order: [] as string[],
      width: {} as Record<string, number>,
    })
  );

  const width = useDeepMemo(
    () => columnSettings.value.width,
    [columnSettings.value.width]
  );

  return useCallback(
    (columns) => {
      Object.entries(width).forEach((colWidth) => {
        const [prop, value] = colWidth;
        const colIdx = columns.findIndex((col) => col.accessor === prop);
        if (columns[colIdx]) {
          columns[colIdx].width = value;
        }
      });
    },
    [width]
  );
};
